module.exports = __webpack_public_path__ + "img/dc5a0341e75ab0c26b39556e9528d3ad.98e96954.png";